module.exports = __webpack_public_path__ + "img/icon_tips@2x.74518588.png";